import { RootState } from '../store';

export const getFundCentreData = (state: RootState) => state.fundCentre;
export const getActiveTabKey = (state: RootState) => state.fundCentre.activeTabKey;
export const getAllFundsCount = (state: RootState) => state.fundCentre.allFundsCount;
export const getSelectedTab = (state: RootState) => state.fundCentre.selectedTab;
export const getFundDetailsPageUrl = (state: RootState) => state.fundCentre.fundDetailsPageUrl;
export const getSearchByISIN = (state: RootState) => state.fundCentre.searchByISIN;
export const getSearchQuery = (state: RootState) => state.fundCentre.searchQuery;
